import { render, staticRenderFns } from "./ReportBoxTrendVendors.vue?vue&type=template&id=a07c3222&"
import script from "./ReportBoxTrendVendors.vue?vue&type=script&lang=js&"
export * from "./ReportBoxTrendVendors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a07c3222')) {
      api.createRecord('a07c3222', component.options)
    } else {
      api.reload('a07c3222', component.options)
    }
    module.hot.accept("./ReportBoxTrendVendors.vue?vue&type=template&id=a07c3222&", function () {
      api.rerender('a07c3222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity/reports/ReportBoxTrendVendors.vue"
export default component.exports